import React, { FC } from 'react';
import { Button } from 'reactstrap';
import { ProductModel } from '../../shared/orders/product';
import { RaffleWithUserDetails } from '../../shared/orders/raffle';
import { isRaffleClosed } from '../models';
import { cToUsdStr } from './cToUsdStr';
import { classNames } from '.';

interface ProductPrice {
  price: string;
  was?: string;
}

interface ProductRawPrice {
  price: number;
  was?: number;
}

export function getProductPrice(
  product: Pick<ProductModel, 'discounts' | 'price'>,
  quantity = 1,
): ProductPrice {
  const { price, was } = getProductRawPrice(product, quantity);

  return {
    price: cToUsdStr(price),
    was: was === undefined ? undefined : cToUsdStr(was),
  };
}

function getProductRawPrice(
  { discounts, price }: Pick<ProductModel, 'discounts' | 'price'>,
  quantity = 1,
): ProductRawPrice {
  if (!discounts || discounts.length === 0) {
    return { price: price * quantity };
  }

  return {
    price: Math.min(...discounts.map(({ price: discountPrice }) => discountPrice)) * quantity,
    was: price * quantity,
  };
}

export function renderPrice({ price, was }: ProductPrice): JSX.Element {
  return (
    <div className={classNames({ productWithDiscount: !!was }, 'productPurchaseBarPrice')}>
      ${price}
      {was && (
        <>
          <br />
          <small>Was ${was}</small>
        </>
      )}
    </div>
  );
}

interface BuyButtonProps {
  readonly product: ProductModel;
  readonly label?: string;
  readonly raffle?: RaffleWithUserDetails;
  onSelect(id: number): void;
}

export const BuyButton: FC<BuyButtonProps> = ({
  product,
  onSelect,
  raffle: userRaffle,
  label = 'Add to Cart',
}) => {
  const { id, stockAvailable, raffle } = product;

  if (isRaffleClosed(userRaffle, raffle)) {
    return (
      <Button color="white" disabled id={`closedRaffle${id}`} outline>
        Closed Raffle
      </Button>
    );
  }

  if (stockAvailable !== undefined && stockAvailable <= 0 && raffle?.overflowEntries !== true) {
    return (
      <Button color="white" disabled outline>
        Sold Out
      </Button>
    );
  }

  return (
    <Button
      className="buy"
      color="success"
      id={`selectProduct${id}`}
      onClick={() => {
        onSelect(id);
      }}
    >
      {label}
    </Button>
  );
};
